import React, { useMemo } from "react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import { Slate, withReact } from "slate-react";
import { withImages } from "../utils/slate";
export const WidgetContextProvider = ({ children, data, }) => {
    const editor = useMemo(() => withImages(withHistory(withReact(createEditor()))), []);
    const initialSlateText = Object.assign({}, data).text;
    return (React.createElement(Slate, { editor: editor, value: initialSlateText }, children));
};
